// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"622":"03460e04","677":"6f60fd81"}[chunkId] + ".js";
};